import React from "react";
import logoSrc from '../img/logo.png';
import './Blog.css';

function Stories() {
  return (
    <>
    <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Blogs Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">stories behind our journey</h1>
            <p className="banner-description">
              Explore the stories that shaped Shigjeta’s path. From our humble beginnings to where we are today, learn about the values, challenges, and milestones along the way.
            </p>
            <a href="/stories" className="banner-button">
              Discover Our Journey
            </a>
          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>

      {/* Stories Section */}
      <section className="about-section">
        {/* Story 1 */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Humble Beginnings</strong></h2>
            <p>
              It all started with a vision to make a difference in the world of business. From a small team with big ideas, Shigjeta grew through dedication and innovation.
            </p>
            <ul>
              <li><strong>Visionary Leadership:</strong> Inspired by the drive to succeed.</li>
              <li><strong>Building the Team:</strong> Collaborating to create something impactful.</li>
              <li><strong>First Steps:</strong> Overcoming challenges and pushing boundaries.</li>
            </ul>
            <button className="cta-button">Read Our Story</button>
          </div>
          <div className="about-image">
            <img src="humble-beginnings.jpg" alt="Humble Beginnings" />
          </div>
        </div>

        {/* Story 2 */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Facing Challenges, Celebrating Milestones</strong></h2>
            <p>
              Every step forward was met with its own set of challenges. Yet, our resilience and commitment to excellence turned each hurdle into a milestone.
            </p>
            <ul>
              <li><strong>Overcoming Adversity:</strong> Turning challenges into growth opportunities.</li>
              <li><strong>Client Success Stories:</strong> Building trust and lasting partnerships.</li>
              <li><strong>Celebrating Progress:</strong> Recognizing our team's collective effort.</li>
            </ul>
            <button className="cta-button">Learn About Our Milestones</button>
          </div>
          <div className="about-image">
            <img src="celebrating-milestones.jpg" alt="Celebrating Milestones" />
          </div>
        </div>

        {/* Story 3 */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Future Vision</strong></h2>
            <p>
              As we look to the future, our mission remains clear – continue innovating, expanding, and making an impact. Shigjeta is more than just a company; it's a movement.
            </p>
            <ul>
              <li><strong>Innovating for Tomorrow:</strong> Always ahead of the curve.</li>
              <li><strong>Global Expansion:</strong> Reaching new markets and opportunities.</li>
              <li><strong>Driving Change:</strong> Empowering businesses to reach new heights.</li>
            </ul>
            <button className="cta-button">Join Our Vision</button>
          </div>
          <div className="about-image">
            <img src="future-vision.jpg" alt="Future Vision" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Stories;
